import tier3BackgroundManaged from "./tier3BackgroundManaged";

export default function () {
  const widgetName = "tier3SeoBlockFeature";
  const widgetOpts = tier3SeoBlockFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    buyNowButton: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    moreButton: false,
    textOverImage: false,
    link: [""],
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(".second-tier-container").remove();
      } else {
        createCustomSeo();
        tier3BackgroundManaged();
      }
    },
  });

  function createCustomSeo() {
    $(`#${widgetName} .card-widget-item`).each(function () {
      let $card = $(this);

      $card.find(".card-content").wrap('<div class="seo-block-layout"></div>');
      $card.find(".buttonwrap").remove();
      $card.find(".image-container, .image-container img").attr({
        "data-aos": "fade-up",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "450",
      });

      $card.find(".card-content").attr({
        "data-aos": "fade-down",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "450",
      });
    });
  }
}
